import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8083';

/** Error carrying the HTTP status and the API error code, e.g. 403 / "owner_required". */
export class ApiError extends Error {
  constructor(message, status, code, details) {
    super(message);
    this.details = details;
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

const http = axios.create({
  baseURL: `${BASE_URL}/c1`,
  withCredentials: true, // shared master session cookie
  timeout: 30000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

function toApiError(err) {
  if (err.response) {
    const body = err.response.data?.error;
    return new ApiError(
      body?.message || `Request failed (${err.response.status})`,
      err.response.status,
      body?.code || null,
      body?.details,
    );
  }
  if (err.code === 'ECONNABORTED') return new ApiError('The request timed out. Please try again.', 0, 'timeout');
  return new ApiError('Cannot reach the OrkaCrew server. Check your connection and try again.', 0, 'network');
}

async function request(config) {
  try {
    const res = await http.request(config);
    return res.data?.data;
  } catch (err) {
    throw toApiError(err);
  }
}

const ApiService = {
  get: (url, params) => request({ method: 'GET', url, params }),
  post: (url, data) => request({ method: 'POST', url, data }),
  put: (url, data) => request({ method: 'PUT', url, data }),
  patch: (url, data) => request({ method: 'PATCH', url, data }),
  del: (url) => request({ method: 'DELETE', url }),
};

export default ApiService;
